var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.92)",
    d: "M19.71 10s-4.198 6.25-9.375 6.25C5.157 16.25.96 10 .96 10s4.197-6.25 9.375-6.25c5.177 0 9.375 6.25 9.375 6.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "var(--icon-stroke-width, 1.92)",
    d: "M14.084 10.058c0 1.973-1.679 3.573-3.75 3.573-2.07 0-3.749-1.6-3.749-3.573 0-1.973 1.679-3.573 3.75-3.573 2.07 0 3.749 1.6 3.749 3.573Z"
  })));
};
export default SvgEye;